import React from "react";
import { useState } from "react";
import Styles from "../../Styles/Resume.module.css"
import edit from "../../Assets/edit.png"
import del from "../../Assets/delete.png";
import add from "../../Assets/add.png";


const Education = () => {
    const [workEducation, setWorkEducation] = useState([
      {
        title: 'Bachelor in Computer Science',
        school: 'University of Ilorin',
        startDate: 'August 2022',
        endDate: 'Present',
        
      },
    ]);
  
    const [newWorkEducation, setNewWorkEducation] = useState({
      title: '',
      school: '',
      startDate: '',
      endDate: '',

    });
  
    const handleAddWorkEducation = () => {
      setWorkEducation([...workEducation, newWorkEducation]);
      setNewWorkEducation({
        title: '',
        school: '',
        startDate: '',
        endDate: '',
       
      });
    };
  
    const handleEditWorkEducation = (index) => {
      const updatedWorkEducation = [...workEducation];
      updatedWorkEducation[index] = newWorkEducation;
      setWorkEducation(updatedWorkEducation);
    };
  
    const handleDeleteWorkEducation = (index) => {
      const updatedWorkEducation = [...workEducation];
      updatedWorkEducation.splice(index, 1);
      setWorkEducation(updatedWorkEducation);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
        <div className={Styles.contents3}>
         {workEducation.map((education, index) => ( 
       <><div key={index} className={Styles.subcontent}>
                 <div className={Styles.subcontent1}>
                     <h1>Education</h1>
                 </div>
                 <div className={Styles.subcontent2}>
                     <img src={add} onClick={() => setModalOpen(true)}  alt="/" width="23.0px" height="23.0px" />
                 </div>
             </div><div className={Styles.subcontent01}>
                     <hr style={{ width: "605px" }}></hr>
                 </div><div className={Styles.subcontent02}>
                     <div className={Styles.subcontent1}>
                         <div className={Styles.text}>
                             <div className={Styles.headertext}>
                                 <h1 style={{ whiteSpace: "nowrap" }}>{education.title}</h1>
                                 <div className={Styles.icon} style={{ whiteSpace: "nowrap" }}>
                                     <img src={edit} alt="/" width="23.0px" height="23.0px" style={{ position: 'relative', right: "30px" }} onClick={() => handleEditWorkEducation()}  />
                                     <img src={del} alt="/" width="20.0px" height="20.0px" onClick={() => handleDeleteWorkEducation(index)}/>
                                 </div>
                             </div>
                             <p>{education.school}</p>
                             <p>{education.startDate} to {education.endDate}</p>
                         </div>
                     </div>
                 </div></>
         ))}
        

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>Degree Title</label>
          <input type="text" value={newWorkEducation.title} onChange={(e) => setNewWorkEducation({ ...newWorkEducation, title: e.target.value })} />
          <label>School</label>
          <input type="text" value={newWorkEducation.school} onChange={(e) => setNewWorkEducation({ ...newWorkEducation, school: e.target.value })} />
          <label>StartDate</label>
          <input type="text" value={newWorkEducation.startDate} onChange={(e) => setNewWorkEducation({ ...newWorkEducation, startDate: e.target.value })} />
          <label>EndDate</label>
          <input type="text" value={newWorkEducation.endDate} onChange={(e) => setNewWorkEducation({ ...newWorkEducation, endDate: e.target.value })} />
          <button onClick={handleAddWorkEducation} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default Education;